import React from 'react';
import Icon from '../../../components/AppIcon';

const QuadrantSelector = ({ urgency, importance, onUrgencyChange, onImportanceChange }) => {
  const getQuadrantInfo = () => {
    if (urgency && importance) {
      return {
        name: 'Do First',
        description: 'Urgent and Important',
        color: 'text-error',
        bgColor: 'bg-error/10',
        icon: 'AlertCircle'
      };
    } else if (!urgency && importance) {
      return {
        name: 'Schedule',
        description: 'Not Urgent but Important',
        color: 'text-primary',
        bgColor: 'bg-primary/10',
        icon: 'Calendar'
      };
    } else if (urgency && !importance) {
      return {
        name: 'Delegate',
        description: 'Urgent but Not Important',
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        icon: 'Users'
      };
    } else {
      return {
        name: 'Eliminate',
        description: 'Not Urgent and Not Important',
        color: 'text-muted-foreground',
        bgColor: 'bg-muted',
        icon: 'Trash2'
      };
    }
  };

  const quadrant = getQuadrantInfo();

  return (
    <div className="w-full space-y-4 md:space-y-5">
      <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
        <button
          type="button"
          onClick={() => onUrgencyChange(!urgency)}
          className={`flex-1 h-12 md:h-14 rounded-lg border-2 transition-all duration-250 flex items-center justify-center gap-2 md:gap-3 ${
            urgency
              ? 'border-error bg-error/10 text-error' :'border-border bg-input text-muted-foreground hover:border-muted-foreground'
          }`}
          aria-pressed={urgency}
        >
          <Icon
            name={urgency ? 'CheckCircle2' : 'Circle'}
            size={20}
            color="currentColor"
          />
          <span className="text-sm md:text-base font-medium">Urgent</span>
        </button>

        <button
          type="button"
          onClick={() => onImportanceChange(!importance)}
          className={`flex-1 h-12 md:h-14 rounded-lg border-2 transition-all duration-250 flex items-center justify-center gap-2 md:gap-3 ${
            importance
              ? 'border-primary bg-primary/10 text-primary' :'border-border bg-input text-muted-foreground hover:border-muted-foreground'
          }`}
          aria-pressed={importance}
        >
          <Icon
            name={importance ? 'CheckCircle2' : 'Circle'}
            size={20}
            color="currentColor"
          />
          <span className="text-sm md:text-base font-medium">Important</span>
        </button>
      </div>
      <div
        className={`p-4 md:p-5 rounded-lg ${quadrant?.bgColor} flex items-center gap-3 md:gap-4`}
      >
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg bg-background/50 flex items-center justify-center ${quadrant?.color}`}>
          <Icon name={quadrant?.icon} size={24} color="currentColor" />
        </div>
        <div className="flex-1">
          <h4 className={`text-base md:text-lg font-semibold ${quadrant?.color}`}>
            {quadrant?.name}
          </h4>
          <p className="text-xs md:text-sm text-muted-foreground mt-0.5">
            {quadrant?.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuadrantSelector;